var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245.667,
    height: 52.971,
    viewBox: "0 0 245.667 52.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logoWhite",
    transform: "translate(1074.941 -137.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-330.51,141.966c5.012.1,9.978-.009,14.911.341,4.815.342,7.412,3.465,7.528,8.35.057,2.42-.149,4.822-1.885,6.669a26.732,26.732,0,0,1-3.538,2.705l2.6,4.9,3.988-4.4h7.876l-9.273,9.083,6.809,13.112h-5.68l-4.7-9.043-3.911,3.941h-7.561l8.64-9.03-4.02-8.048h-6.632v10.44h-5.154Zm5.163,14.5c2.856-.107,5.677-.086,8.469-.361a3.829,3.829,0,0,0,3.471-3.685,10.517,10.517,0,0,0,.028-1.975c-.19-2.285-1.409-3.771-3.668-3.983-2.737-.257-5.5-.221-8.3-.313Z",
    transform: "translate(-536.191 -3.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-525.428,190.426h-5.413l-6.18-21.534h5.419l3.919,15.869,4.254-15.845h4.462l4.036,15.993,4.174-16.016h5.125l-6.244,21.491h-5.615l-3.951-13.965-3.985,14.008",
    transform: "translate(-387.447 -22.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-1052.156,141.507c-.1,1.631-.191,3.123-.279,4.554-2.062-.253-4.075-.542-6.1-.734a13.082,13.082,0,0,0-5.682.622,7.274,7.274,0,0,0-4.921,5.412,17.338,17.338,0,0,0-.059,8.123,7.566,7.566,0,0,0,7.484,6.335,35.95,35.95,0,0,0,3.686-.049,11.418,11.418,0,0,0,1.486-.26V155.473h5.051V169.3c-1.575.3-3.171.688-4.788.909a24.188,24.188,0,0,1-8.693-.132,11.51,11.51,0,0,1-9.222-8.832,20.859,20.859,0,0,1,.32-12.16,11.686,11.686,0,0,1,9.725-8.185c4-.693,7.943-.158,11.988.6",
    transform: "translate(0 -2.18)",
    fill: "#f05917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-718.395,167.418h3.818l.519,2.574c.433-.4.771-.734,1.125-1.046,3.573-3.148,11.448-3.391,13.736,3.814a16.462,16.462,0,0,1,.06,9.939c-1.278,4.2-4.779,6.665-9.427,6.674-1.609,0-3.219-.223-4.886-.348v8.25h-4.945Zm4.945,17.24a10.152,10.152,0,0,0,5.327.469,4.9,4.9,0,0,0,4.089-3.369,11.178,11.178,0,0,0-.079-7.842,4.04,4.04,0,0,0-3.8-2.838,6.5,6.5,0,0,0-5.349,2.68.969.969,0,0,0-.179.58c-.01,3.422-.008,6.844-.008,10.32",
    transform: "translate(-256.809 -21.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-399.192,184.2v4.047c-4.2,1.365-8.41,1.943-12.686.692-3.409-1-5.32-3.461-6.072-6.843a16.651,16.651,0,0,1,.215-8.118,8.984,8.984,0,0,1,8.924-6.891,17.262,17.262,0,0,1,4.2.395c3.469.832,5.675,3.786,5.911,7.708a22.8,22.8,0,0,1-.032,2.612c-.031.562-.156,1.119-.251,1.761h-14.053a4.983,4.983,0,0,0,4.327,5.694,20.335,20.335,0,0,0,8.543-.784c.313-.079.622-.173.977-.272m-4.51-7.982c.252-3.216-1.3-5.177-4.081-5.241a4.843,4.843,0,0,0-5.3,5.241Z",
    transform: "translate(-472.921 -21.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-971.448,179.573c-.146,3.557,2.092,5.751,5.836,5.873a24.065,24.065,0,0,0,7.2-.994l.925-.252v3.979a15.8,15.8,0,0,1-5.756,1.291,29.209,29.209,0,0,1-5.822-.255c-4.058-.707-6.415-3.327-7.241-7.3a16.554,16.554,0,0,1,.264-7.939,8.937,8.937,0,0,1,8.922-6.883,17.405,17.405,0,0,1,4.28.428,7.646,7.646,0,0,1,5.749,7.15c.124,1.6-.019,3.213-.041,4.9Zm9.493-3.338c0-3.537-1.428-5.228-4.342-5.248-3.085-.021-5.091,2.014-5.133,5.248Z",
    transform: "translate(-70.785 -21.279)",
    fill: "#f05918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-786.193,179.6h-14.122c-.11,3.515,2.094,5.68,5.835,5.808a23.933,23.933,0,0,0,7.2-.986c.287-.079.574-.156.92-.25v4.051c-4.354,1.394-8.731,2.014-13.158.532a8.168,8.168,0,0,1-5.4-5.948,16.065,16.065,0,0,1,.149-9.235,8.9,8.9,0,0,1,8.735-6.52,17.6,17.6,0,0,1,3.5.223,7.782,7.782,0,0,1,6.55,6.844,15.472,15.472,0,0,1-.2,5.481m-14.074-3.412h9.365c.352-2.961-1.171-5.063-3.743-5.225-3.389-.214-5.551,1.766-5.621,5.225",
    transform: "translate(-194.05 -21.241)",
    fill: "#f05918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-884.7,174.233V189h-4.907V167.533h3.809l.5,2.71c.355-.338.635-.639.949-.9a9.65,9.65,0,0,1,9.715-1.77c2.546.85,3.828,2.878,4.252,5.459a14.727,14.727,0,0,1,.171,2.332c.016,4.207.008,8.414.008,12.621,0,.325,0,.65,0,1.03h-5.025v-.952q0-6.04,0-12.08c0-3.945-2.422-5.64-6.14-4.3a7.437,7.437,0,0,0-3.33,2.544",
    transform: "translate(-133.488 -21.193)",
    fill: "#f05918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-623.675,170.387l.9,2.222c-3.489,1.521-9.642.97-13.913-3.084a14.044,14.044,0,0,1-2.98-16.009,13.77,13.77,0,0,1,13.011-8l-1.742,7.448a6.712,6.712,0,0,0-4.694,4.006,6.217,6.217,0,0,0,1.863,7.4c1.483,1.038,1.947,2.469,2.546,3.955-3.127-.1-6.4-3.214-7.262-6.923a9.243,9.243,0,0,1,5.569-10.552l.524-2.321a11.242,11.242,0,0,0-8.492,11.889,11.545,11.545,0,0,0,14.668,9.976",
    transform: "translate(-312.578 -5.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-571.45,191.843a11.676,11.676,0,0,0,5.814-11.95c-.383.126-.682.217-.975.324s-.557.219-.929.366l-.9-2.21,4.429-1.78a13.782,13.782,0,0,1-6.49,17.58l-.95-2.33",
    transform: "translate(-362.649 -28.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-233.5,139.665a5.935,5.935,0,0,1,6.016,5.894,6.016,6.016,0,0,1-6,6.038,5.955,5.955,0,0,1-5.951-5.971,5.894,5.894,0,0,1,5.933-5.962m.076,11.252a5.283,5.283,0,0,0,5.282-5.351,5.374,5.374,0,0,0-5.374-5.3,5.383,5.383,0,0,0-5.286,5.4,5.289,5.289,0,0,0,5.378,5.258",
    transform: "translate(-601.788 -1.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-585.857,142.874q.019.968.039,1.937l.435,1.085,1.077,2.2-1.15.821c-.584-1.394-1.259-2.7-1.679-4.083a4.214,4.214,0,0,1,1.558-4.655,13.54,13.54,0,0,1,5.662-2.61c.32-.08.732.2,1.1.315l.013.395a11.894,11.894,0,0,1-1.091.6c-1.176.5-2.364.98-3.546,1.468l-.981.616-1.092,1.18-.344.728",
    transform: "translate(-351.208)",
    fill: "#3d3289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-584.509,194.373l.867-1.635-.007-1.028-1.46-3.857.891-.6a10.325,10.325,0,0,1,1.882,4.358,4.3,4.3,0,0,1-1.336,3.847,12.6,12.6,0,0,1-5.722,2.883,3.009,3.009,0,0,1-.922-.041c-.316-.788.178-1,.651-1.2.633-.261,1.28-.488,1.921-.73l.917-.389,1.7-1.041.619-.564",
    transform: "translate(-348.989 -35.794)",
    fill: "#3d3289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-582.054,154.693l.344-.728c2.441.832,4.88,1.669,7.327,2.485a1.12,1.12,0,0,0,.752.006c.706-.33,1.313-.317,1.655.453a.973.973,0,0,1-.541,1.417c-.763.3-1.268-.03-1.521-.787-.018-.053-.071-.095-.168-.218l-7.848-2.627",
    transform: "translate(-355.011 -11.82)",
    fill: "#5d9e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-593.883,198.74l-.619.565-6.932-3.954c-1.281.226-1.871.018-1.979-.735a1.052,1.052,0,0,1,.871-1.27c.674-.166,1.152.288,1.34,1.258l7.319,4.135",
    transform: "translate(-339.615 -40.16)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-585.039,189.611q0,.514.007,1.027l-5.147-3.888c-1.334.254-2.065-.1-2.161-1.02a1.31,1.31,0,0,1,1.227-1.392c.863-.041,1.323.537,1.357,1.784l4.717,3.489",
    transform: "translate(-347.598 -33.695)",
    fill: "#5d9e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-581.48,164.578l-.435-1.085,4.736,2.183c1.2-.534,1.94-.379,2.256.472a1.27,1.27,0,0,1-.786,1.673c-.8.264-1.411-.205-1.815-1.461l-3.955-1.782",
    transform: "translate(-355.111 -18.683)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-576.922,148.16l.981-.616,5.551,1.229c.61-.3,1.28-.724,1.8.093a.884.884,0,0,1-.31,1.328c-.758.428-1.236-.012-1.594-.673l-6.423-1.361",
    transform: "translate(-358.707 -7.195)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-576.554,178.325a1.581,1.581,0,0,1-1.622,1.554,1.591,1.591,0,0,1-1.506-1.593,1.587,1.587,0,0,1,1.589-1.6,1.578,1.578,0,0,1,1.538,1.637",
    transform: "translate(-356.72 -28.186)",
    fill: "#5a9d35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-595.225,209.187l-.917.389-4.211-2.2c-.739.252-1.428.295-1.68-.607a.861.861,0,0,1,.711-1.15c.766-.151,1.191.246,1.247,1.019l4.85,2.549",
    transform: "translate(-340.589 -49.002)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-554.06,142.835a3.151,3.151,0,0,1-.985.382c-.154.007-.457-.4-.456-.618s.3-.635.453-.629a3.175,3.175,0,0,1,.993.381q0,.242,0,.483",
    transform: "translate(-374.136 -3.181)",
    fill: "#64a13e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M-597.1,218.624c-.333-.51-.666-.8-.629-1.022.041-.258.412-.462.64-.69.223.23.591.439.628.7.033.228-.3.509-.639,1.015",
    transform: "translate(-343.722 -57.159)",
    fill: "#5e9e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M-216.469,157.839l-1.144-3.272c-.206,1.172.092,2.163-.223,3.035l-.389-.065v-4.061h.812l1.151,3.313,1.172-3.291.736-.091v4.151c-.418-.141-.418-.141-.521-2.967-.654.978-.56,2.278-1.594,3.25",
    transform: "translate(-617.066 -11.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M-230.432,153.844v3.5l-.687.1v-3.583l-1.485-.111c.224-.232.32-.422.451-.451.926-.207,2.711,0,3.114.454l-1.393.087",
    transform: "translate(-606.709 -11.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M-832.675,300.7l.351-.036.024.713a17.356,17.356,0,0,1-2.358.194,2.125,2.125,0,0,1-1.85-.756,4.057,4.057,0,0,1-.544-2.351q0-3.18,2.527-3.18a2.312,2.312,0,0,1,1.825.683,3.181,3.181,0,0,1,.6,2.146l-.048.689h-3.99a2.478,2.478,0,0,0,.363,1.487,1.482,1.482,0,0,0,1.263.484q.9,0,1.832-.072m-.326-2.624a2.625,2.625,0,0,0-.357-1.572,1.379,1.379,0,0,0-1.161-.459,1.487,1.487,0,0,0-1.209.483,2.439,2.439,0,0,0-.417,1.548Z",
    transform: "translate(-171.344 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M-812.978,301.446h-.907V295.4h.895v.423a3.863,3.863,0,0,1,1.874-.544,1.787,1.787,0,0,1,1.626.653,4.611,4.611,0,0,1,.417,2.321v3.192h-.895v-3.168a4.087,4.087,0,0,0-.248-1.723,1.088,1.088,0,0,0-1.058-.466,3.153,3.153,0,0,0-.816.115,4.08,4.08,0,0,0-.659.224l-.23.109Z",
    transform: "translate(-188.03 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M-786.862,300.7l.35-.036.024.713a17.355,17.355,0,0,1-2.358.194,2.125,2.125,0,0,1-1.85-.756,4.057,4.057,0,0,1-.544-2.351q0-3.18,2.527-3.18a2.312,2.312,0,0,1,1.826.683,3.181,3.181,0,0,1,.6,2.146l-.048.689h-3.99a2.48,2.48,0,0,0,.362,1.487,1.483,1.483,0,0,0,1.264.484q.9,0,1.832-.072m-.326-2.624a2.625,2.625,0,0,0-.357-1.572,1.379,1.379,0,0,0-1.161-.459,1.487,1.487,0,0,0-1.209.483,2.44,2.44,0,0,0-.417,1.548Z",
    transform: "translate(-204.341 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M-766.472,291.736h-1.922v2.89a3.9,3.9,0,0,0,.151,1.366q.151.326.719.326l1.076-.073.061.75a8.272,8.272,0,0,1-1.233.133,1.579,1.579,0,0,1-1.306-.459,3,3,0,0,1-.363-1.753v-3.18h-.858v-.786h.858V289.1h.895v1.85h1.922Z",
    transform: "translate(-219.534 -109.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M-752.642,287.069h.907v1.052h-.907Zm0,2.418h.907v6.045h-.907Z",
    transform: "translate(-232.142 -107.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M-741.181,295.281a10.443,10.443,0,0,1,1.354.145l.29.036-.036.738a14.21,14.21,0,0,0-1.426-.109,1.659,1.659,0,0,0-1.4.49,3.183,3.183,0,0,0-.369,1.814,3.546,3.546,0,0,0,.345,1.843,1.616,1.616,0,0,0,1.433.52l1.427-.109.036.75a12.442,12.442,0,0,1-1.68.169,2.29,2.29,0,0,1-1.953-.725,4.223,4.223,0,0,1-.538-2.448,3.836,3.836,0,0,1,.581-2.418,2.391,2.391,0,0,1,1.934-.7",
    transform: "translate(-238.585 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M-711.94,287.761q-1.813,0-1.813,1.366a1.178,1.178,0,0,0,.417,1.046,5.57,5.57,0,0,0,1.693.568,4.3,4.3,0,0,1,1.807.738,1.864,1.864,0,0,1,.532,1.493q0,2.575-2.672,2.575a14.962,14.962,0,0,1-2.212-.206l-.435-.06.1-.774a20.666,20.666,0,0,0,2.5.218q1.789,0,1.789-1.68a1.142,1.142,0,0,0-.393-.973,3.827,3.827,0,0,0-1.469-.5,4.949,4.949,0,0,1-2.007-.78,1.944,1.944,0,0,1-.592-1.6q0-2.249,2.7-2.249a14.867,14.867,0,0,1,2.116.181l.411.06-.084.786a22.7,22.7,0,0,0-2.382-.206",
    transform: "translate(-259.473 -107.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M-688.237,295.281a10.444,10.444,0,0,1,1.354.145l.29.036-.036.738a14.206,14.206,0,0,0-1.426-.109,1.659,1.659,0,0,0-1.4.49,3.183,3.183,0,0,0-.369,1.814,3.546,3.546,0,0,0,.345,1.843,1.616,1.616,0,0,0,1.433.52l1.427-.109.036.75a12.444,12.444,0,0,1-1.68.169,2.29,2.29,0,0,1-1.953-.725,4.223,4.223,0,0,1-.538-2.448,3.838,3.838,0,0,1,.581-2.418,2.392,2.392,0,0,1,1.934-.7",
    transform: "translate(-276.719 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M-670.611,287.069h.907v1.052h-.907Zm0,2.418h.907v6.045h-.907Z",
    transform: "translate(-291.226 -107.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M-657.331,300.7l.35-.036.024.713a17.356,17.356,0,0,1-2.358.194,2.125,2.125,0,0,1-1.85-.756,4.059,4.059,0,0,1-.544-2.351q0-3.18,2.527-3.18a2.311,2.311,0,0,1,1.826.683,3.181,3.181,0,0,1,.6,2.146l-.048.689h-3.99a2.479,2.479,0,0,0,.363,1.487,1.482,1.482,0,0,0,1.263.484q.9,0,1.832-.072m-.326-2.624a2.625,2.625,0,0,0-.357-1.572,1.379,1.379,0,0,0-1.161-.459,1.487,1.487,0,0,0-1.209.483,2.44,2.44,0,0,0-.417,1.548Z",
    transform: "translate(-297.639 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M-637.635,301.446h-.907V295.4h.895v.423a3.865,3.865,0,0,1,1.874-.544,1.787,1.787,0,0,1,1.626.653,4.611,4.611,0,0,1,.417,2.321v3.192h-.895v-3.168a4.089,4.089,0,0,0-.248-1.723,1.088,1.088,0,0,0-1.058-.466,3.155,3.155,0,0,0-.816.115,4.084,4.084,0,0,0-.659.224l-.23.109Z",
    transform: "translate(-314.324 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M-613.337,295.281a10.442,10.442,0,0,1,1.354.145l.29.036-.036.738a14.2,14.2,0,0,0-1.426-.109,1.66,1.66,0,0,0-1.4.49,3.186,3.186,0,0,0-.369,1.814,3.541,3.541,0,0,0,.345,1.843,1.615,1.615,0,0,0,1.432.52l1.427-.109.036.75a12.441,12.441,0,0,1-1.68.169,2.29,2.29,0,0,1-1.953-.725,4.223,4.223,0,0,1-.538-2.448,3.837,3.837,0,0,1,.58-2.418,2.392,2.392,0,0,1,1.934-.7",
    transform: "translate(-330.667 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M-592.544,300.7l.351-.036.024.713a17.356,17.356,0,0,1-2.357.194,2.125,2.125,0,0,1-1.85-.756,4.059,4.059,0,0,1-.544-2.351q0-3.18,2.527-3.18a2.311,2.311,0,0,1,1.826.683,3.181,3.181,0,0,1,.6,2.146l-.048.689H-596a2.479,2.479,0,0,0,.363,1.487,1.483,1.483,0,0,0,1.264.484q.9,0,1.832-.072m-.326-2.624a2.625,2.625,0,0,0-.357-1.572,1.379,1.379,0,0,0-1.161-.459,1.487,1.487,0,0,0-1.209.483,2.44,2.44,0,0,0-.417,1.548Z",
    transform: "translate(-344.303 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-563.858,304.131V295.4h.895v.436a3.486,3.486,0,0,1,1.813-.556,1.905,1.905,0,0,1,1.669.731,4.275,4.275,0,0,1,.52,2.412,3.771,3.771,0,0,1-.611,2.412,2.5,2.5,0,0,1-2.025.731,6.444,6.444,0,0,1-1.354-.133v2.7Zm2.575-8.04a2.811,2.811,0,0,0-.78.121,4.059,4.059,0,0,0-.659.242l-.229.121v4.074a9.226,9.226,0,0,0,1.306.133,1.566,1.566,0,0,0,1.372-.556,3.219,3.219,0,0,0,.393-1.813,3.35,3.35,0,0,0-.356-1.789,1.18,1.18,0,0,0-1.046-.532",
    transform: "translate(-368.117 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M-541.644,298.412a3.835,3.835,0,0,1,.593-2.394,2.425,2.425,0,0,1,2-.738,2.408,2.408,0,0,1,2,.738,3.868,3.868,0,0,1,.586,2.394,4.088,4.088,0,0,1-.556,2.406,2.383,2.383,0,0,1-2.031.749,2.381,2.381,0,0,1-2.031-.749,4.085,4.085,0,0,1-.556-2.406m.931-.018a3.847,3.847,0,0,0,.321,1.856,1.447,1.447,0,0,0,1.342.532,1.439,1.439,0,0,0,1.336-.526,3.893,3.893,0,0,0,.314-1.856,3.4,3.4,0,0,0-.351-1.832,1.482,1.482,0,0,0-1.3-.5,1.5,1.5,0,0,0-1.306.5,3.343,3.343,0,0,0-.357,1.825",
    transform: "translate(-384.117 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M-519.471,295.713h.907l1.221,5.259h.194l1.439-5.138h.943l1.439,5.138h.206l1.209-5.259h.907l-1.439,6.045h-1.511l-1.282-4.727-1.282,4.727h-1.511Z",
    transform: "translate(-400.088 -113.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M-481.166,300.7l.351-.036.024.713a17.355,17.355,0,0,1-2.357.194,2.124,2.124,0,0,1-1.85-.756,4.056,4.056,0,0,1-.544-2.351q0-3.18,2.527-3.18a2.312,2.312,0,0,1,1.826.683,3.183,3.183,0,0,1,.6,2.146l-.048.689h-3.99a2.479,2.479,0,0,0,.363,1.487,1.482,1.482,0,0,0,1.263.484q.9,0,1.832-.072m-.326-2.624a2.628,2.628,0,0,0-.356-1.572,1.38,1.38,0,0,0-1.161-.459,1.488,1.488,0,0,0-1.209.483,2.439,2.439,0,0,0-.417,1.548Z",
    transform: "translate(-424.525 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M-462.375,301.415V295.37h.895v.822a5.892,5.892,0,0,1,2.213-.955v.919a6.512,6.512,0,0,0-1.058.3,7.045,7.045,0,0,0-.84.362l-.3.157v4.437Z",
    transform: "translate(-441.212 -113.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M-444.039,300.7l.351-.036.024.713a17.355,17.355,0,0,1-2.357.194,2.124,2.124,0,0,1-1.85-.756,4.056,4.056,0,0,1-.544-2.351q0-3.18,2.527-3.18a2.312,2.312,0,0,1,1.826.683,3.183,3.183,0,0,1,.6,2.146l-.048.689h-3.99a2.479,2.479,0,0,0,.363,1.487,1.482,1.482,0,0,0,1.263.484q.9,0,1.832-.072m-.326-2.624a2.627,2.627,0,0,0-.356-1.572,1.38,1.38,0,0,0-1.161-.459,1.488,1.488,0,0,0-1.209.483,2.439,2.439,0,0,0-.417,1.548Z",
    transform: "translate(-451.266 -113.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M-421.292,286.291v8.681h-.895v-.411a3.685,3.685,0,0,1-1.838.532,2.68,2.68,0,0,1-.846-.121,1.734,1.734,0,0,1-.677-.435,3.41,3.41,0,0,1-.653-2.412,4.285,4.285,0,0,1,.587-2.539,2.272,2.272,0,0,1,1.94-.78,7.608,7.608,0,0,1,1.487.157v-2.672Zm-3.143,7.907a1.57,1.57,0,0,0,.562.085,3.024,3.024,0,0,0,.774-.115,4.639,4.639,0,0,0,.671-.224l.242-.109v-4.1a7.858,7.858,0,0,0-1.439-.145,1.385,1.385,0,0,0-1.281.586,3.552,3.552,0,0,0-.363,1.82,2.992,2.992,0,0,0,.423,1.886,1.039,1.039,0,0,0,.411.314",
    transform: "translate(-467.267 -107.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M-389.428,288.806a1.949,1.949,0,0,1,1.711.7,4.434,4.434,0,0,1,.49,2.436,3.783,3.783,0,0,1-.611,2.448,2.871,2.871,0,0,1-2.243.707q-.508,0-1.68-.1l-.339-.036v-8.669h.895v2.938a4.24,4.24,0,0,1,1.777-.423m-.665,5.477a1.826,1.826,0,0,0,1.566-.538,3.259,3.259,0,0,0,.381-1.82,3.808,3.808,0,0,0-.3-1.8,1.143,1.143,0,0,0-1.076-.514,4.232,4.232,0,0,0-1.439.266l-.242.085v4.256q.786.06,1.112.06",
    transform: "translate(-491.829 -107.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M-371.4,295.713h.907l1.511,5.259h.4l1.523-5.259h.907l-2.515,8.729h-.907l.786-2.684h-.895Z",
    transform: "translate(-506.741 -113.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M-336.712,295.781h-.931v-8.366h.931v3.893l1.378-.048,2.14-3.845h1.064l-2.394,4.207,2.527,4.159h-1.1l-2.224-3.7-1.391.048Z",
    transform: "translate(-531.053 -107.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M-277.351,295.781V292h-4.256v3.784h-.931v-8.366h.931v3.748h4.256v-3.748h.919v8.366Z",
    transform: "translate(-570.743 -107.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M-311.171,291.233a2.019,2.019,0,0,1-1.137-2.363,2.077,2.077,0,0,1,2.052-1.67,12.61,12.61,0,0,1,2.572.128c.168.021.288.433.5.778-1.033-.062-1.833-.166-2.63-.145-1.039.029-1.578.561-1.6,1.436-.023.942.46,1.466,1.586,1.516,1.348.06,2.7.014,4.129.014,0,.249.044.585-.007.6-.79.231-.463.845-.469,1.325a2.645,2.645,0,0,1-2.687,2.862,9.117,9.117,0,0,1-1.037,0,2.461,2.461,0,0,1-2.531-1.568c-.348-1.119.011-1.993,1.261-2.915m1.732,3.74a8.514,8.514,0,0,0,1.336-.289,2.072,2.072,0,0,0,1.044-2.413c-.184-.97-.975-.58-1.525-.623a6.393,6.393,0,0,0-1.717.117,1.537,1.537,0,0,0-1.269,1.923c.146.8.854,1.209,2.13,1.285",
    transform: "translate(-549.121 -107.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M-858.72,292.1v2.5a9.157,9.157,0,0,1-1.729.17,1.992,1.992,0,0,1-1.862-.8,5.449,5.449,0,0,1-.484-2.672,5.45,5.45,0,0,1,.484-2.672,2.007,2.007,0,0,1,1.874-.8,15.873,15.873,0,0,1,2.6.254l.036-.774-.411-.072a11.9,11.9,0,0,0-2.333-.242,2.8,2.8,0,0,0-2.509,1.058,5.939,5.939,0,0,0-.707,3.252,5.907,5.907,0,0,0,.707,3.246,2.83,2.83,0,0,0,2.533,1.052,14.7,14.7,0,0,0,2.72-.29v-3.2Z",
    transform: "translate(-152.105 -107.628)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.838728ab5ecea314818abe170112245d.svg";
export { ForwardRef as ReactComponent };